export const wrapper = {
  my: 3
};

if (typeof wrapper !== 'undefined' && wrapper && wrapper === Object(wrapper) && Object.isExtensible(wrapper) && !wrapper.hasOwnProperty('__filemeta')) {
  Object.defineProperty(wrapper, '__filemeta', {
    configurable: true,
    value: {
      name: "wrapper",
      filename: "../../node_modules/gatsby-theme-docz/src/components/NavGroup/styles.js"
    }
  });
}

export const sublinkWrapper = {
  ml: 2
};

if (typeof sublinkWrapper !== 'undefined' && sublinkWrapper && sublinkWrapper === Object(sublinkWrapper) && Object.isExtensible(sublinkWrapper) && !sublinkWrapper.hasOwnProperty('__filemeta')) {
  Object.defineProperty(sublinkWrapper, '__filemeta', {
    configurable: true,
    value: {
      name: "sublinkWrapper",
      filename: "../../node_modules/gatsby-theme-docz/src/components/NavGroup/styles.js"
    }
  });
}

export const title = {
  mb: 1,
  fontSize: 2,
  fontWeight: 500,
  color: 'sidebar.navGroup',
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
};

if (typeof title !== 'undefined' && title && title === Object(title) && Object.isExtensible(title) && !title.hasOwnProperty('__filemeta')) {
  Object.defineProperty(title, '__filemeta', {
    configurable: true,
    value: {
      name: "title",
      filename: "../../node_modules/gatsby-theme-docz/src/components/NavGroup/styles.js"
    }
  });
}

export const chevron = ({
  active
}) => ({
  ml: 1,
  flexShrink: 0,
  alignSelf: 'baseline',
  transform: `rotateX(${active ? 180 : 0}deg)`,
  transformOrigin: 'center',
  transition: 'transform .3s ease-in-out'
});

if (typeof chevron !== 'undefined' && chevron && chevron === Object(chevron) && Object.isExtensible(chevron) && !chevron.hasOwnProperty('__filemeta')) {
  Object.defineProperty(chevron, '__filemeta', {
    configurable: true,
    value: {
      name: "chevron",
      filename: "../../node_modules/gatsby-theme-docz/src/components/NavGroup/styles.js"
    }
  });
}